import {addBrowserSideAppHeaders} from '@/utils/unityHeaders';
import {fetchWithRetry} from '@/utils/fetchWithRetry';

export default async function heartbeat() {
  const headers = {};
  await addBrowserSideAppHeaders(headers);

  return fetchWithRetry('/api/hb', {
    method: 'POST',
    headers,
  });
}
